/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
export const PAGINATION_COUNT_ITEM = 20;
export const MIN_PAGINATION_COUNT_ITEM = 5;
export const MAX_PAGINATION_COUNT_ITEM = 1000;
export const START_TIME_TO_DAY_PERIOD = '08:00';
export const ASCENDING = 'asc';
export const DESCENDING = 'desc';
export const FULL_DAY = 'fullDay';
export const DAY = 'day';
export const DATE_LONG_WITH_DAY_NAME = 'dateLongWithDayName';
export const ALL_PRICES_ID = 'allPrices';
export const YES = 'Да';
export const NO = 'Нет';

export const CRUD_OPERATIONS = {
    EDIT: 'EDIT',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    LOCK: 'LOCK',
    UNLOCK: 'UNLOCK',
    SAVE: 'SAVE',
    CANCEL: 'CANCEL',
    TRANSFER: 'TRANSFER',
    ADD: 'ADD',
};

export const RU_CRUD_OPERATIONS = {
    DELETE: 'удалить',
    LOCK: 'заблокировать',
    SAVE: 'сохранить',
    UPDATE: 'изменить',
};

export const ERRORS_STATUS = {
    ERROR: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    UNPROCESSABLE_ENTITY_ERROR: 422,
    SERVER_ERROR: 500,
};

export const ERRORS_MESSAGES = { FAILED_TO_FETCH: 'Failed to fetch' };

export const SAVED_CLIENT = 'SAVED_CLIENT';
export const COOKIE_POLICY_URL = 'https://aibolit.by/cookie-policy';

export const PERMISSIONS = {
    VARIANT_AVVA: 'variant:avva',
    MENU_REPORTS_VISIBLE: 'menu:reports:visible',
    MENU_PATIENTS_VISIBLE: 'menu:patients:visible',
    MENU_RECEPTION_VISIBLE: 'menu:reception:visible',
    MENU_BOOKINGS_VISIBLE: 'menu:bookings:visible',
    MENU_POLICIES_VISIBLE: 'menu:policies:visible',
    MENU_CONTRACTS_VISIBLE: 'menu:contracts:visible',
    MENU_CATALOGS_VISIBLE: 'menu:catalogs:visible',
    MENU_SETTINGS_VISIBLE: 'menu:settings:visible',
    // MENU_SERVICE_LIST_VISIBLE: 'menu:service_list:visible',
    MENU_SCHEDULES_VISIBLE: 'menu:schedules:visible',
    MENU_WORKING_SHIFTS_VISIBLE: 'menu:schedules:visible',
    MENU_PRICES_VISIBLE: 'menu:prices:visible',
    VISIT_VISIT_CREATE: 'visit:visit:create',
    VISIT_VISIT_CREATE_IN_THE_PAST: 'visit:visit:create_in_the_past',
    VISIT_VISIT_CANCEL: 'visit:visit:cancel',
    VISIT_VISIT_COME: 'visit:visit:come',
    VISIT_VISIT_SERVICES_EDIT: 'visit:visit:services_edit',
    PAYMENT_PAYMENT_CREATE: 'payment:payment:create',
    PAYMENT_PAYMENT_CANCEL: 'payment:payment:cancel',
    PAYMENT_PAYMENT_DELETE: 'payment:payment:delete',
    SPECIALIST_PRIVATE_DATA_VISIBLE: 'specialist:private_data:visible',
};

export const SETTINGS = {
    PATIENT_CARD_AUTO_ASSIGNING: 'PATIENT_CARD_AUTO_ASSIGNING',
    BILL_IS_REQUIRED: 'BILL_IS_REQUIRED',
    REGISTRATION_ADDRESS_IS_REQUIRED: 'REGISTRATION_ADDRESS_IS_REQUIRED',
    SOURCE_OF_CLIENT_IS_REQUIRED: 'SOURCE_OF_CLIENT_IS_REQUIRED',
};

export const ENTITY_TYPES = {
    DOCTORS_AUTHORISATION: 'DOCTORS_AUTHORISATION',
    DOCTOR_REMOVE_BRANCH: 'DOCTOR_REMOVE_BRANCH',
};
